<template>
  <div class="wrap">
    <el-card class="box-card stockCard" shadow="never" id="stockrise_card">
      <el-row :gutter="10">
        <el-col :span="8">
          <div class="stockIndex">
            <div class="graph-title-row">
              <div class="graph-title">
                <router-link
                  :to="{ name: 'Stockdetailed', query: { symbol: 'sh000001' } }"
                  style="color: #fff"
                >
                  {{ $t('stockrise.exchange') }}
                </router-link>
              </div>
            </div>
            <div class="stockImg">
              <router-link
                :to="{ name: 'Stockdetailed', query: { symbol: 'sh000001' } }"
              >
                <el-image
                  src="//image.sinajs.cn/newchart/small/nsh000001.gif"
                  style="width: 85%"
                ></el-image>
              </router-link>
            </div>
            <p class="stockUp" v-if="indexDetail.changepercent[0]">
              <span
                class="red"
                v-if="indexDetail.changepercent[0].substr(0, 1) === '+'"
                >{{ indexDetail.trade[0] }} {{ indexDetail.changepercent[0] }}%
                {{ indexDetail.marketCapitalization[0] }}{{$t('stockRise.millionYuan')}}</span
              >
              <span class="green" v-else
                >{{ indexDetail.trade[0] }} {{ indexDetail.changepercent[0] }}%
                {{ indexDetail.marketCapitalization[0] }}{{$t('stockRise.millionYuan')}}</span
              >
            </p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stockIndex">
            <div class="graph-title-row">
              <div class="graph-title">
                <router-link
                  :to="{ name: 'Stockdetailed', query: { symbol: 'sz399001' } }"
                  style="color: #fff"
                >
                  {{ $t('stockrise.deepinto') }}
                </router-link>
              </div>
            </div>
            <div class="stockImg">
              <router-link
                :to="{ name: 'Stockdetailed', query: { symbol: 'sz399001' } }"
              >
                <el-image
                  src="//image.sinajs.cn/newchart/small/nsz399001.gif"
                  style="width: 85%"
                ></el-image>
              </router-link>
            </div>
            <p class="stockUp" v-if="indexDetail.changepercent[1]">
              <span
                class="red"
                v-if="indexDetail.changepercent[1].substr(0, 1) === '+'"
                >{{ indexDetail.trade[1] }} {{ indexDetail.changepercent[1] }}%
                {{ indexDetail.marketCapitalization[1] }}{{$t('stockRise.millionYuan')}}</span
              >
              <span class="green" v-else
                >{{ indexDetail.trade[1] }} {{ indexDetail.changepercent[1] }}%
                {{ indexDetail.marketCapitalization[1] }}{{$t('stockRise.millionYuan')}}</span
              >
            </p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stockIndex">
            <div class="graph-title-row">
              <div class="graph-title">
                <router-link
                  :to="{ name: 'Stockdetailed', query: { symbol: 'sz399415' } }"
                  style="color: #fff"
                >
                  {{ $t('stockrise.bigdata') }}
                </router-link>
              </div>
            </div>
            <div class="stockImg">
              <router-link
                :to="{ name: 'Stockdetailed', query: { symbol: 'sz399415' } }"
              >
                <el-image
                  src="//image.sinajs.cn/newchart/small/nsz399415.gif"
                  style="width: 85%"
                ></el-image>
              </router-link>
            </div>
            <p class="stockUp" v-if="indexDetail.changepercent[2]">
              <span
                class="red"
                v-if="indexDetail.changepercent[2].substr(0, 1) === '+'"
                >{{ indexDetail.trade[2] }} {{ indexDetail.changepercent[2] }}%
                {{ indexDetail.marketCapitalization[2] }}{{$t('stockRise.millionYuan')}}</span
              >
              <span class="green" v-else
                >{{ indexDetail.trade[2] }} {{ indexDetail.changepercent[2] }}%
                {{ indexDetail.marketCapitalization[2] }}{{$t('stockRise.millionYuan')}}</span
              >
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <div class="main">
      <el-table
        :data="tableData"
        size="mini"
        style="width: 100%"
        :header-cell-style="{ border: 'none' }"
        :cell-style="{ border: 'none' }"
      >
        <el-table-column fixed align="center" :label="$t('stockRise.theCode')">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'Stockdetailed',
                query: { symbol: scope.row.symbol },
              }"
              class="stockLinkColor"
            >
              <span>{{ scope.row.symbol }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column fixed align="center" prop="name" :label="$t('stockRise.name')">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'Stockdetailed',
                query: { symbol: scope.row.symbol },
              }"
              class="stockLinkColor"
            >
              <span>{{ scope.row.name }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="trade" :label="$t('stockRise.latestPrice')">
        </el-table-column>
        <el-table-column align="center" prop="pricechange" :label="$t('stockRise.changeAmount')">
        </el-table-column>
        <el-table-column align="center" prop="changepercent" :label="$t('stockRise.quoteChange')">
        </el-table-column>
        <el-table-column align="center" prop="buy" :label="$t('stockRise.buy')">
        </el-table-column>
        <el-table-column align="center" prop="sell" :label="$t('stockRise.sell')">
        </el-table-column>
        <el-table-column align="center" prop="settlement" :label="$t('stockRise.receivedYesterday')">
        </el-table-column>
        <el-table-column align="center" prop="open" :label="$t('stockRise.openToday')">
        </el-table-column>
        <el-table-column align="center" prop="high" :label="$t('stockRise.highest')">
        </el-table-column>
        <el-table-column align="center" prop="low" :label="$t('stockRise.lowest')">
        </el-table-column>
        <!--<el-table-column
            align="center"
            width="120"
            prop="volume"
            label="成交量/手">
            <template slot-scope="scope">
              <span>{{ scope.row.volume.toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="120"
            prop="amount"
            label="成交额/万">
            <template slot-scope="scope">
              <span>{{ scope.row.amount.toLocaleString() }}</span>
            </template>
          </el-table-column>-->
      </el-table>
    </div>
    <div class="pagination" id="stockrise_pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="this.pagesize"
        :prev-text="$t('stockrise.previoustxt')"
        :next-text="$t('stockrise.next')"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "stockrise",
  data() {
    return {
      tableData: [],
      indexDetail: {
        trade: [],
        changepercent: [],
        marketCapitalization: []
      },
      total: 3809,//默认数据总数
      pagesize: 15,//每页的数据条数
      currentPage: 1,//默认开始页面
    };
  },
  methods: {
    getIndexData() {
      let that = this;
      let shortArr = ["s_sh000001", "s_sz399001", "s_sz399415"];
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          let indexDetail = { trade: [], changepercent: [], marketCapitalization: [] };
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            indexDetail.trade.push(elements[3]);
            if (elements[5].substr(0, 1) === '-') {
              indexDetail.changepercent.push(elements[5]);
            } else {
              indexDetail.changepercent.push('+' + elements[5]);
            }
            indexDetail.marketCapitalization.push((parseInt(elements[7]) / 1000).toFixed(2));
          }
          that.indexDetail = indexDetail;
        }
      });
    },
    getTableCount() {
      let that = this;
      that
        .$http({
          url: "/app/Stock/stock_count",
          method: "post",
          data: {
          }
        }).then(ret => {
          let resData = ret.data;
          if (ret.status == 200) {
            this.total = parseInt(resData.data);
          } else {
            that.$alert(this.$t('stockRise.pleaseTryLater'), this.$t('stockRise.hint'), {
              confirmButtonText: this.$t('stock.sure'),
              // callback: action => that.getTableCount()
            })
          }
        });
    },
    getTableData() {
      let that = this;
      that
        .$http({
          url: "/app/Stock/stock_change",
          method: "post",
          data: {
            'pageNo': this.currentPage,
            'asc': 0,
            'num': 15
          }
        }).then(ret => {
          let resData = ret.data;
          if (resData.status == 200) {
            this.tableData = resData.data;
          } else {
            that.$alert(this.$t('stockRise.pleaseTryLater'), this.$t('stockRise.hint'), {
              confirmButtonText: this.$t('stock.sure'),
              // callback: action => that.getTableData()
            })
          }
        });
    },
    //页码变更
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    }
  },
  mounted: function () {
    let that = this;
    this.getIndexData();
    this.chatTimer = setInterval(function () {
      that.getIndexData();
    }, 10000);
    this.getTableCount();
    this.getTableData();
  },
  beforeDestroy() {
    clearTimeout(this.chatTimer);
  }
}
</script>

<style scoped>
.stockIndex {
  margin: 0 auto;
  text-align: center;
  background-color: #ffffff;
  border-radius: 15px;
  padding-bottom: 10px;
}

.stockCard {
  background: none;
  border: none;
}

.stockImg {
  margin: 5px auto;
}

.stockUp {
  line-height: 24px;
  font-size: 12px;
  width: 85%;
  height: 24px;
  background: #f3f3f5;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /*加宽度width属来兼容部分浏览*/
  margin: 10px auto;
}
.main {
  margin-top: 10px;
  padding: 10px;
  border-radius: 15px;
  background-color: #ffffff;
}
.stockLinkColor {
  color: var(--baseColor);
}
.stockLinkColor :hover {
  color: #b43512;
}
.green {
  color: #008000;
}
.wrap {
}

.pagination {
  margin: 0 auto;
  text-align: center;
}

.graph-title-row {
  display: flex;
  align-items: flex-start;
}

.graph-title {
  border-radius: 15px 0px 15px 0px;
  background-color: var(--baseColor);
  padding: 7px 20px;
  font-size: 10px;
  color: #ffffff;
}

#stockrise_card >>> .el-card__body {
  padding: 0;
}
#stockrise_pagination >>> .el-pagination {
  display: flex;
  justify-content: flex-end;
}
#stockrise_pagination >>> .btn-next {
  padding: 5px;
  border-radius: 10px;
  height: 36px;
  border: none;
  color: var(--baseColor);
}
#stockrise_pagination >>> .btn-prev {
  padding: 5px;
  border-radius: 10px;
  height: 36px;
  border: none;
  color: var(--baseColor);
}
#stockrise_pagination >>> .el-pagination.is-background .el-pager li {
  height: 36px;
  border-radius: 10px;
  border: none;
  color: var(--baseColor);
  line-height: 36px;
}
#stockrise_pagination >>> .el-pager li.active {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/stockrise.vue